import { render, staticRenderFns } from "./ExpertFeedbackWrapper.vue?vue&type=template&id=feb0a996&scoped=true&"
import script from "./ExpertFeedbackWrapper.vue?vue&type=script&lang=js&"
export * from "./ExpertFeedbackWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ExpertFeedbackWrapper.vue?vue&type=style&index=0&id=feb0a996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb0a996",
  null
  
)

export default component.exports